import { forwardRef } from "react";
import styles from "./separator.module.css";

interface ISeparatorProps {
  direction: "vertical" | "horizontal";
  className?: string;
}

const Separator = forwardRef<HTMLDivElement, ISeparatorProps>(
  ({ className, direction = "horizontal", ...props }, ref) => (
    <div ref={ref} {...props} className={`${styles[direction]} ${className}`} />
  )
);
Separator.displayName = "Separator";

export default Separator;
